module.exports = __webpack_public_path__ + "static/media/card-empty.85d0988e.png";